import axios from "axios";
const url = process.env.REACT_APP_API_URI;

export const ipdReg = (data) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/IPD`, data);
  };

  export const fetchIpd = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/IPD/Admitted`);
  };

  export const fetchBedList = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Bed`);
  };

  export const fetchCardList = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Card`);
  };

  export const getPackageDrop = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Package`);
  }

  
